import { useLocation, useNavigate } from "react-router-dom";

import { ToastContainer } from "react-toastify";
import "./App.css";
import MainRoutes from "./router";

function App() {
  return (
    <div className="App">
      <ToastContainer />
      <MainRoutes />
    </div>
  );
}

export default App;
